const principles = [
  "渠道真实可查，不罗列失效入口",
  "信息求新，优先标注当前开放的投稿通道",
  "守边界，不鼓励捏造与恶意扩散",
  "持续维护，随时同步渠道开放状态",
];

const testimonials = [
  {
    name: "匿名瓜友",
    meta: "短线索投稿",
    text: "之前总找不到能用的入口，照着这里的方法整理时间线一次就过了，编辑还追问了细节，体验很顺。",
  },
  {
    name: "夜宵吃瓜人",
    meta: "邮箱长文",
    text: "带证据的长文走邮箱很省心，截图按时间排好发过去，审稿明显快了很多，附件的整理建议很实用。",
  },
  {
    name: "工位前排观众",
    meta: "在线表单",
    text: "不想加好友，走在线链接一步提交最合适。字段很清楚，材料齐全的话当天就有编辑联系了。",
  },
  {
    name: "摸鱼观察员",
    meta: "社群留言",
    text: "社群留言适合先探个口风，编辑有回应再补材料，灵活又不尴尬。这类辅助入口说明得很到位。",
  },
];

export default function About() {
  return (
    <section id="about" className="scroll-mt-24 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-14">
          <div>
            <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-800">
              <i className="ri-information-line" aria-hidden="true"></i>
              关于我们
            </span>
            <h2 className="mt-4 text-2xl font-bold text-foreground-950 md:text-4xl">
              瓜田投递站是什么？
            </h2>
            <p className="mt-5 text-base leading-relaxed text-foreground-600">
              瓜田投递站是一份持续维护的「吃瓜投稿指南」。我们把当前开放接收投稿的微信、邮箱、链接与社群渠道整理成清晰入口，帮投稿人省去到处打听、逐个试错的时间，把手里的瓜料用最顺的路径递到编辑手上。
            </p>

            <div className="mt-8 grid grid-cols-2 gap-4">
              <div className="rounded-2xl bg-background-100 p-5">
                <div className="font-heading text-3xl font-bold text-accent-600">4 类</div>
                <p className="mt-1 text-sm text-foreground-600">常用投稿入口常年更新</p>
              </div>
              <div className="rounded-2xl bg-background-100 p-5">
                <div className="font-heading text-3xl font-bold text-primary-600">100%</div>
                <p className="mt-1 text-sm text-foreground-600">原则为「真实、可核实」</p>
              </div>
              <div className="rounded-2xl bg-accent-100/70 p-5 col-span-2">
                <p className="text-sm font-semibold text-accent-900">我们的内容原则</p>
                <ul className="mt-3 flex flex-col gap-2">
                  {principles.map((p) => (
                    <li key={p} className="flex items-start gap-2 text-sm text-accent-900/90">
                      <i className="ri-checkbox-circle-line mt-0.5 shrink-0 text-accent-600" aria-hidden="true"></i>
                      {p}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold text-foreground-950 md:text-xl">投稿人怎么说</h3>
            <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {testimonials.map((t) => (
                <figure
                  key={t.name}
                  className="flex flex-col rounded-2xl border border-background-200/70 bg-background-100/50 p-5"
                >
                  <div className="flex gap-0.5 text-secondary-500">
                    {[0, 1, 2, 3, 4].map((s) => (
                      <i key={s} className="ri-star-fill text-sm" aria-hidden="true"></i>
                    ))}
                  </div>
                  <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                    「{t.text}」
                  </blockquote>
                  <figcaption className="mt-4 flex items-center gap-2.5 border-t border-background-200/70 pt-3">
                    <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-500 text-background-50">
                      <i className="ri-user-line text-sm" aria-hidden="true"></i>
                    </span>
                    <span>
                      <span className="block text-sm font-semibold text-foreground-950">{t.name}</span>
                      <span className="block text-xs text-foreground-500">{t.meta}</span>
                    </span>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}